module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/widget-advertencias.4cdf0e62.svg";